import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { Checkbox, EnumDropdown, ModalFormButton } from 'framework/form';
import { useAuthorization } from 'framework/authorization';
import { useShowContext } from 'framework/show';
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee';
import usePositionSlotsService from '../usePositionSlotsService';
import { POSITION_SLOT_UPDATE } from '../constants';
import type { PositionSlotListItem } from '../types';
import { getUpdatePositionSlotValidationSchema } from '../validation/positionSlotValidation';

const UpdatePositionSlotModalButton = ({ onSuccess }: { onSuccess: () => void }) => {
  const { isGranted } = useAuthorization();
  const { data } = useShowContext();
  const positionSlotData = data.getData() as unknown as PositionSlotListItem;
  const { updatePositionSlot } = usePositionSlotsService();
  const isWorkRateTypeReadOnly = Boolean(
    positionSlotData.employeeAlias ||
    positionSlotData.employeeAliases?.length ||
    positionSlotData.vacancyId ||
    positionSlotData.positionFulfillmentRequestId,
  );

  if (!isGranted(POSITION_SLOT_UPDATE)) {
    return null;
  }

  return (
    <ModalFormButton
      label={<AppRegistrationIcon color="primary" sx={{ fontSize: 20 }} />}
      formTitle="Update position slot"
      getValidationSchemaFunc={getUpdatePositionSlotValidationSchema}
      getDataFunc={async () => ({
        isMarkedForDeletion: positionSlotData.isMarkedForDeletion ?? false,
        workRateType: positionSlotData.workRateType,
      })}
      submitFormFunc={formData => updatePositionSlot(positionSlotData, formData)}
      afterSubmit={{
        execute: onSuccess,
        message: 'Position slot has been successfully updated.',
      }}
      color="transparent"
      sxButton={{
        minWidth: 'auto',
        p: 0,
      }}
    >
      <EnumDropdown
        source="workRateType"
        label="FTE"
        options={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES}
        isRequired
        disabled={isWorkRateTypeReadOnly}
      />
      <Checkbox source="isMarkedForDeletion" label="Marked for archival" />
    </ModalFormButton>
  );
};

export default UpdatePositionSlotModalButton;
